import { render } from "./leydocumento.vue?vue&type=template&id=d8f0abd4&scoped=true"
import script from "./leydocumento.vue?vue&type=script&lang=js"
export * from "./leydocumento.vue?vue&type=script&lang=js"

import "./leydocumento.vue?vue&type=style&index=0&id=d8f0abd4&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f0abd4"]])

export default __exports__